import React from 'react'
import { ReactComponent as KeypadHideIcon } from 'assets/svg/dialpad/keypad-hide.svg'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

export const HideKeypadButton = ({ onClick }) => {
    const history = useHistory()
    const { t } = useTranslation()

    function onCLickHandle() {
        if (typeof onClick === 'function') {
            onClick()
        } else {
            history.goBack()
        }
    }

    return (
        <button
            type="button"
            className="dialpad__keypad-page__hide-btn d-flex flex-column justify-content-center align-items-center"
            onClick={onCLickHandle}
        >
            <KeypadHideIcon className="dialpad__keypad-page__hide-btn__ico" />
            {t('hide')}
        </button>
    )
}
